@if (widget().componentListType) {
  <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
    <mat-tab label="{{ 'Details' | transloco }}">
      <div class="sidebar-content--detail-tab">
        <div class="sidebar-content--detail-tab__container-content" data-userguide="editor-sidebar_content">
          <div>
            <span class="tt-guideline-editor-component-list-sidebar-wrapper_component-list-type-label">
              {{ 'GuidelineEditor.Sidebar.Widgets.GuidelineEditor.ComponentListTypeLabel' | transloco }}
            </span>
            <div class="tt-guideline-editor-component-list-sidebar-wrapper_component-list-type">
              @switch (widget().componentListType) {
                @case (ComponentListType.Conditions) {
                  <span>{{ 'GuidelineEditor.Sidebar.Widgets.GuidelineEditor.Condition' | transloco }}</span>
                }
                @case (ComponentListType.Criteria) {
                  <span>{{ 'GuidelineEditor.Sidebar.Widgets.GuidelineEditor.Criteria' | transloco }}</span>
                }
                @case (ComponentListType.DiagnosisPlan) {
                  <span>{{ 'GuidelineEditor.Sidebar.Widgets.GuidelineEditor.DiagnosticPlan' | transloco }}</span>
                }
              }
              <button ttButton [variant]="'secondary'" (click)="resetComponentListType()">
                {{ 'GuidelineEditor.Sidebar.Widgets.GuidelineEditor.Reset' | transloco }}
              </button>
            </div>
          </div>

          <tt-form-field class="sidebar-selection-behavior_select" id="expand-strategy-select">
            <label for="expand-strategy-select">{{ 'Sidebar.ExpandComponentsOnRead' | transloco }}:</label>
            <tt-select
              data-testid="expand-strategy-select"
              [selected]="widget().componentExpandStrategyOnRead"
              (selectionChanged)="setExpandComponentsOnRead($event)">
              <tt-select-items>
                @if (widget().componentListType === ComponentListType.Criteria) {
                  <tt-option [value]="ComponentExpandStrategy.Default">{{ 'Sidebar.DefaultBehavior.Criteria' | transloco }}</tt-option>
                } @else {
                  <tt-option [value]="ComponentExpandStrategy.Default">
                    {{ 'Sidebar.DefaultBehavior.DefaultCollapsed' | transloco }}
                  </tt-option>
                }
                <tt-option [value]="ComponentExpandStrategy.Expanded">{{ 'Sidebar.ExpandComponents' | transloco }}</tt-option>
                <tt-option [value]="ComponentExpandStrategy.Collapsed">{{ 'Sidebar.CollapseComponents' | transloco }}</tt-option>
              </tt-select-items>
            </tt-select>
          </tt-form-field>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
}
